import React from "react";
import { createStore } from "redux";
import { rootReducer } from "./app.store";
import { Provider } from "react-redux";
import { Route, Redirect, Router } from "react-router-dom";
import { composeWithDevTools } from "redux-devtools-extension";
import EmptyPage from "./modules/core/empty";
import LoginPage from "./modules/account/login-page";

import LayoutApp from "./shared/layout/layout-app";
import AuthManagement from "shared/components/auth/auth-management";
import history from "shared/plugins/history";

import { Loading } from "shared/components/loading/loading";
import Profile from "modules/profile/profile";
import { ToastComponent } from "shared/components/toast/toast";
import { ModalComponent } from "shared/components/modal/modal-confirm";
import Address from "modules/address/address";
import AddressAddUpdate from "modules/address/address-add-update";
import Order from "modules/order/order";
import OrderDetail from "modules/order/order-detail";

const store = createStore(rootReducer, composeWithDevTools());

function App() {
  return (
    <Provider store={store}>
      <Router history={history}>
        <Route path="/account/login" exact={true} component={LoginPage} />
        <Route path="/account/empty" exact={true} component={EmptyPage} />
        <LayoutApp>
          <Route path={["/","/account"]} exact={true}>
            <Redirect to="/account/profile"></Redirect>
          </Route>
          <Route path="/account/profile" exact={true} component={Profile} />
          <Route path="/account/addresses" exact={true} component={Address} />
          <Route path="/account/addresses/add" exact={true} component={AddressAddUpdate} />
          <Route path="/account/addresses/edit/:id" exact={true} component={AddressAddUpdate} />
          <Route path="/account/orders" exact={true} component={Order} />
          <Route path="/account/orders/:orderId" exact={true} component={OrderDetail} />
        </LayoutApp>
        <ModalComponent />
        <ToastComponent />
        <AuthManagement></AuthManagement>
        <Loading />
      </Router>
    </Provider>
  );
}

export default App;
